export default __webpack_public_path__ + "static/media/beqLKDmh.0a3a2329.svg";